/**
 * @generated SignedSource<<93edb09b2549830a1db5ec4fd0366673>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type TransportationCode = "CADDIE" | "CADDIE_CART" | "CART" | "FULL_CART" | "MOTOR_PULL_CART" | "PRIVATE_CART" | "PULL_CART" | "SINGLE_CART" | "WALK";
import { FragmentRefs } from "relay-runtime";
export type TransportationTypeSelectNode$data = {
  readonly transportationTypes: ReadonlyArray<{
    readonly code: TransportationCode | null | undefined;
    readonly customCode: string | null | undefined;
    readonly eighteenHolePrice: number | null | undefined;
    readonly enabled: boolean;
    readonly id: string;
    readonly name: string | null | undefined;
    readonly nineHolePrice: number | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "TransportationTypeSelectNode";
};
export type TransportationTypeSelectNode$key = {
  readonly " $data"?: TransportationTypeSelectNode$data;
  readonly " $fragmentSpreads": FragmentRefs<"TransportationTypeSelectNode">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "memberId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "TransportationTypeSelectNode",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "memberId",
          "variableName": "memberId"
        },
        {
          "kind": "Literal",
          "name": "memberVisible",
          "value": true
        }
      ],
      "concreteType": "TransportationType",
      "kind": "LinkedField",
      "name": "transportationTypes",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customCode",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "enabled",
          "storageKey": null
        },
        {
          "alias": "nineHolePrice",
          "args": [
            {
              "kind": "Literal",
              "name": "holeCount",
              "value": "NINE"
            }
          ],
          "kind": "ScalarField",
          "name": "totalPrice",
          "storageKey": "totalPrice(holeCount:\"NINE\")"
        },
        {
          "alias": "eighteenHolePrice",
          "args": [
            {
              "kind": "Literal",
              "name": "holeCount",
              "value": "EIGHTEEN"
            }
          ],
          "kind": "ScalarField",
          "name": "totalPrice",
          "storageKey": "totalPrice(holeCount:\"EIGHTEEN\")"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Slot",
  "abstractKey": "__isSlot"
};

(node as any).hash = "09359cdb6c1aae41b0202aa9618e4e31";

export default node;
